import React, { Component } from 'react';
import ReactPlayer from 'react-player';
class VideoPlayer extends Component {
   
    render() {
        const style = {
            backgroundColor: 'black',
        };
        if (this.props.src) {
            return (
                <ReactPlayer url={this.props.src} controls light={this.props.thumbnail} style={style} />
            )
        }
        return null;
    }
}
export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/app/components/VideoPlayer.js